import { ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';

import { environment } from '../../environments/environment';
import { AuthActionTypes } from '../afb-graphql-api/actions/auth.actions';
import { CoreActionTypes } from '../core/actions/core.actions';
import * as fromCore from '../core/reducers/core.reducer';
import * as fromAirData from '../core/store/reducers/air-data.reducer';
import * as fromAvgAirData from '../core/store/reducers/avg-air-data.reducer';
import * as fromCoreGroup from '../core/store/reducers/group.reducer';
import * as fromTrigger from '../core/store/reducers/trigger.reducer';
import * as fromCoreUser from '../core/store/reducers/user.reducer';

// import {RouterStateUrl} from '../shared/utils';
// import * as fromUser from '../core/reducers/coreUser.reducer';
// import * as fromAuth from '../core/reducers/auth.reducer';
// import * as fromOrg from '../core/reducers/organization.reducer';
// import * as fromGroup from '../core/reducers/group.reducer';
// from core
// import {OrgUser} from '../core/models/coreUser';
// import {Group} from '../core/models/group';

// /**
//  * storeFreeze prevents state from being mutated. When mutation occurs, an
//  * exception will be thrown. This is useful during development mode to
//  * ensure that none of the reducers accidentally mutates the state.
//  */
// import { storeFreeze } from 'ngrx-store-freeze';
//
// /**
//  * Every reducer module's default export is the reducer function itself. In
//  * addition, each module should export a type or interface that describes
//  * the state of the reducer plus any selector functions. The `* as`
//  * notation packages up all of the exports into a single object.
//  */
//
// import * as fromLayout from '../core/reducers/layout';

/**
 * As mentioned, we treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
export interface State {
  // auth: fromAuth.State;
  core: fromCore.State;
  // device: fromDevice.State;
  // group: fromGroup.State;
  // organization: fromOrg.State;
  // coreUser: fromUser.State;
  // router: fromRouter.RouterReducerState<RouterStateUrl>;

  // coreDevice: fromCoreDevice.State;
  coreGroup: fromCoreGroup.State;
  coreUser: fromCoreUser.State;
  airData: fromAirData.State;
  avgAirData: fromAvgAirData.State;
  trigger: fromTrigger.State;
}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<State> = {
  core: fromCore.reducer,
  // auth: fromAuth.reducer,
  // device: fromDevice.reducer,
  // group: fromGroup.reducer,
  // organization: fromOrg.reducer,
  // coreUser: fromUser.reducer,
  // router: fromRouter.routerReducer,

  // coreDevice: fromCoreDevice.reducer,
  coreGroup: fromCoreGroup.reducer,
  coreUser: fromCoreUser.reducer,
  airData: fromAirData.reducer,
  avgAirData: fromAvgAirData.reducer,
  trigger: fromTrigger.reducer
};

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function(state: State, action: any): State {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export function resetState(
  reducer: ActionReducer<State>
): ActionReducer<State> {
  return function(state: State, action: any): State {
    return reducer(
      action.type === AuthActionTypes.Logout ||
        action.type === CoreActionTypes.ClearState
        ? undefined
        : state,
      action
    );
  };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [logger, resetState]
  : [resetState];

/**
 * Auth Reducers
 */
// export const authState = createFeatureSelector<fromAuth.State>('auth');
//
// export const accessToken = createSelector(
//   authState,
//   fromAuth.accessToken
// );
//
// export const getOrgTokenMap = createSelector(
//   authState,
//   fromAuth.getOrgTokenMap
// );
//
// export const getIsLoggingIn = createSelector(
//   authState,
//   fromAuth.getIsLoggingIn
// );
//
// export const getIsLoggedIn = createSelector(
//   authState,
//   fromAuth.getIsLoggedIn
// );

/**
 * User Reducers
 */
// export const userState = createFeatureSelector<fromUser.State>('coreUser');
//
// export const user = createSelector(
//   userState,
//   fromUser.user
// );
//
// export const getOrgUser = createSelector(
//   userState,
//   fromUser.getOrgUser
// );
//
// export const isGetUserLoaded = createSelector(
//   userState,
//   fromUser.isGetUserLoaded
// );
//
// export const isOrgUserLoaded = createSelector(
//   userState,
//   fromUser.isOrgUserLoaded
// );
//
// export const isUserError = createSelector(
//   userState,
//   fromUser.isUserError
// );
//
// export const isOrgUserError = createSelector(
//   userState,
//   fromUser.isOrgUserError
// );

// export const getUserTempUnit = createSelector(getOrgUser, (orgUser: OrgUser) => orgUser ? orgUser.temp_unit : null);
//
// export const isOrgUserPatched = createSelector(
//   userState,
//   fromUser.isOrgUserPatched
// );
//
// export const isOrgUserPatchError = createSelector(
//   userState,
//   fromUser.isOrgUserPatchError
// );

/**
 * Organization Reducers
 */
// export const getOrgState = createFeatureSelector<fromOrg.State>('organization');
// //
// // export const getOrgList = createSelector(
// //   getOrgState,
// //   fromOrg.getOrgList
// // );
// //
// // export const getOrgListLoaded = createSelector(
// //   getOrgState,
// //   fromOrg.getOrgListLoaded
// // );
// //
// // export const getOrgUserMap = createSelector(
// //   getOrgState,
// //   fromOrg.getOrgUserMap
// // );
// //
// // export const getSelectedOrgWithToken = createSelector(
// //   getOrgState,
// //   fromOrg.getSelectedOrgWithToken
// // );

/**
 * Group Reducers
 */
// export const getGroupState = createFeatureSelector<fromGroup.State>('group');
//
// export const getGroupMap = createSelector(
//   getGroupState,
//   fromGroup.getGroupMap
// );
//
// export const getGroupList = createSelector(getGroupMap, (groupMap: { [groupId: number]: Group }) => {
//   return Object.keys(groupMap).reduce((groupList: Group[], groupId: string) => [...groupList, groupMap[groupId]], []);
// });
//
// export const isGroupListLoaded = createSelector(
//   getGroupState,
//   fromGroup.isGroupListLoaded
// );
//
// export const isGroupListError = createSelector(
//   getGroupState,
//   fromGroup.isGroupListError
// );
//
// export const isGroupCreated = createSelector(
//   getGroupState,
//   fromGroup.isGroupCreated
// );
//
// export const isCreateGroupError = createSelector(
//   getGroupState,
//   fromGroup.isCreateGroupListError
// );

/**
 * Core State
 */
export const coreState = createFeatureSelector<fromCore.State>('core');

export const selectedOrganization = createSelector(
  coreState,
  fromCore.selectedOrganization
);
export const selectedOrganizationError = createSelector(
  coreState,
  fromCore.selectedOrganizationError
);

/**
 * Device State
 */
// export const deviceState = createFeatureSelector<fromDevice.State>('device');
// export const deviceEntities = createSelector(
//   deviceState,
//   fromDevice.deviceEntities
// );
// export const devices = createSelector(
//   deviceEntities,
//   (entities: { [deviceUuid: string]: Device }) => {
//     return Object.keys(entities).reduce((devices: Device[], deviceUuid: string) => [...devices, entities[deviceUuid]], []);
//   });
// export const devicesWithUuid = createSelector(
//   deviceEntities,
//   (entities: { [deviceUuid: string]: Device }) => {
//     return Object.keys(entities).reduce((devicesWithUuid: DeviceWithUuid[], deviceUuid: string) => [
//       ...devicesWithUuid,
//       {
//         ...entities[deviceUuid],
//         uuid: deviceUuid
//       }
//     ], []);
//   }
// );
// export const isGetDevicesLoaded = createSelector(
//   deviceState,
//   fromDevice.isGetDevicesLoaded
// );
// export const getDevicesError = createSelector(
//   deviceState,
//   fromDevice.getDevicesError
// );

/**
 * core states
 */
// export const getCoreDeviceState = (state: State) => state.coreDevice;

// export const deviceEntities = createSelector(getCoreDeviceState, fromCoreDevice.deviceMarkerEntities);
// // export const getDeviceUuidList = createSelector(getCoreDeviceState, fromCoreDevice.getDeviceUuidList);
// export const selectedDeviceUuids = createSelector(getCoreDeviceState, fromCoreDevice.selectedDeviceUuids);
// // export const getDeviceList = createSelector(deviceEntities, getDeviceUuidList, (deviceEntities, deviceUuids) => {
// //   return deviceUuids.map((deviceUuid: string) => deviceEntities[deviceUuid]);
// // });
// export const selectedDevices = createSelector(deviceEntities, selectedDeviceUuids,
//   (deviceEntities, selectedDeviceUuids) => {
//     return selectedDeviceUuids.map((selectedDeviceUuid: string) => deviceEntities[selectedDeviceUuid]);
//   }
// );
// export const getDeviceLoadingStatus = createSelector(getCoreDeviceState, fromCoreDevice.getLoadingStatus);

/* Core Group Selectors */
export const getCoreGroupState = (state: State) => state.coreGroup;

export const getCoreGroupEntities = createSelector(
  getCoreGroupState,
  fromCoreGroup.getEntities
);
export const getCoreGroupIdList = createSelector(
  getCoreGroupState,
  fromCoreGroup.getIdList
);
export const getCoreGroupSelectedGroupId = createSelector(
  getCoreGroupState,
  fromCoreGroup.getSelectedId
);

export const getCoreGroupList = createSelector(
  getCoreGroupEntities,
  getCoreGroupIdList,
  (groupEntities, groupIdList) => {
    return groupIdList.map((groupId: string) => groupEntities[groupId]);
  }
);
export const getCoreSelectedGroup = createSelector(
  getCoreGroupEntities,
  getCoreGroupSelectedGroupId,
  (groupEntities, selectedGroupId) => {
    return selectedGroupId != null ? groupEntities[selectedGroupId] : null;
  }
);
export const getCoreGroupLoadingStatus = createSelector(
  getCoreGroupState,
  fromCoreGroup.getLoadingStatus
);

/* User Selectors */
// export const getCoreUserState = (state: State) => state.coreUser;
//
// export const getOrgUserList = createSelector(getCoreUserState, fromCoreUser.getOrgUserList);

/* User Selectors */
export const getUserState = (state: State) => state.coreUser;

export const getSelf = createSelector(
  getUserState,
  fromCoreUser.getSelf
);
export const getSelfOrgInfo = createSelector(
  getUserState,
  fromCoreUser.getSelfOrgInfo
);
export const getOrgUserList = createSelector(
  getUserState,
  fromCoreUser.getOrgUserList
);
export const getUserRetrievingStatus = createSelector(
  getUserState,
  fromCoreUser.getRetrievingStatus
);
export const getUserInvitingOrgStatus = createSelector(
  getUserState,
  fromCoreUser.getInvitingOrgStatus
);
export const getUserInvitingGroupStatus = createSelector(
  getUserState,
  fromCoreUser.getInvitingGroupStatus
);
export const getUserRemovingOrgStatus = createSelector(
  getUserState,
  fromCoreUser.getRemovingFromOrgStatus
);
export const getUserRemovingGroupStatus = createSelector(
  getUserState,
  fromCoreUser.getRemovingFromGroupStatus
);

/* Air Data Selectors */
export const getAirDataState = (state: State) => state.airData;

export const getAirDataEntities = createSelector(
  getAirDataState,
  fromAirData.getEntities
);
export const getAirDataSelectedDeviceUuidList = createSelector(
  getAirDataState,
  fromAirData.getSelectedDeviceUuidList
);
export const getAirDataTimeRange = createSelector(
  getAirDataState,
  fromAirData.getTimeRange
);
export const getAirDataLoadingStatus = createSelector(
  getAirDataState,
  fromAirData.getLoadingStatus
);
export const getAirDataList = createSelector(
  getAirDataEntities,
  getAirDataSelectedDeviceUuidList,
  (airDataEntities, deviceUuidList) => {
    return deviceUuidList.map(
      (deviceUuid: string) => airDataEntities[deviceUuid]
    );
  }
);

/* Avg Air Data Selectors */
export const getAvgAirDataState = (state: State) => state.avgAirData;

export const getAvgAirData = createSelector(
  getAvgAirDataState,
  fromAvgAirData.getAvgAirData
);
export const getSelectedGroupId = createSelector(
  getAvgAirDataState,
  fromAvgAirData.getSelectedGroupId
);
export const getAvgAirDataTimeRange = createSelector(
  getAvgAirDataState,
  fromAvgAirData.getTimeRange
);
export const getAvgAirDataLoadingStatus = createSelector(
  getAvgAirDataState,
  fromAvgAirData.getLoadingStatus
);

/* Trigger Selectors */
export const getTriggerState = (state: State) => state.trigger;

export const getTriggerEntities = createSelector(
  getTriggerState,
  fromTrigger.getEntities
);
export const getTriggerRetrievingStatus = createSelector(
  getTriggerState,
  fromTrigger.getRetrievingStatus
);
export const getTriggerSettingStatus = createSelector(
  getTriggerState,
  fromTrigger.getSettingStatus
);
